import {Action} from '@ngrx/store';
import {SpecialOfferModel} from '../special-offer.model';

export const GET_SPECIAL_OFFER_ACTUAL = 'GET_SPECIAL_OFFER_ACTUAL';
export const SAVE_SPECIAL_OFFER_ACTUAL = 'SAVE_SPECIAL_OFFER_ACTUAL';
export const USE_SPECIAL_OFFER = 'USE_SPECIAL_OFFER';
export const CLOSE_SPECIAL_OFFER = 'CLOSE_SPECIAL_OFFER';

export const LOCAL_STORAGE_KEY = 'special-offer-close-state';


export class GetSpecialOfferActual implements Action {
  readonly type = GET_SPECIAL_OFFER_ACTUAL;
}

export class SaveSpecialOfferActual implements Action {
  readonly type = SAVE_SPECIAL_OFFER_ACTUAL;

  public constructor(
    public payload: SpecialOfferModel
  ) {
  }
}

export class UseSpecialOffer implements Action {
  readonly type = USE_SPECIAL_OFFER;

  public constructor(
    public payload: number
  ) {
  }
}

export class CloseSpecialOffer implements Action {
  readonly type = CLOSE_SPECIAL_OFFER;

  public constructor(
    public payload: number
  ) {
  }
}

export type SpecialOfferActions = GetSpecialOfferActual | SaveSpecialOfferActual | UseSpecialOffer | CloseSpecialOffer;
